import { ActionReducer } from '@ngrx/store';
import { ApplicationDetail } from '../../model/application/application-detail.model';
import * as application from '../../actions/application-detail.actions';
import * as applicationDelete from '../../actions/application-delete.actions';
import { toggleAccountGroups } from '../../../../core/reducers/toggle-account-groups.reducer';
import { toggleEnableProductAccountGroups } from '../../../../core/reducers/toggle-enable-product-account-groups.reducer';
import { copyShown } from '../../../../core/helpers/account-group.helper';

const toggleAppDetailAccountGroup:
    ActionReducer<ApplicationDetail> = (state: ApplicationDetail, action: application.ToggleAccountGroupAction) => {
    if (state.appId !== action.payload.appId) {
        return state;
    }
    return {...state, accountsGroups: toggleAccountGroups(state.accountsGroups, action)};
};

const toggleAppDetailEnableProduct:
    ActionReducer<ApplicationDetail> = (state: ApplicationDetail, action: application.ToggleEnableProductAction) => {
    if (state.appId !== action.payload.appId) {
        return state;
    }
    return {...state, accountsGroups: toggleEnableProductAccountGroups(state.accountsGroups, action)};
};

/**
 * Function copy shown flag from src to dest, so that expanded account groups remain expanded after reverting changes.
 * @param {ApplicationDetail} src source
 * @param {ApplicationDetail} dest destination
 */
export const keepShown = (src: ApplicationDetail, dest: ApplicationDetail): ApplicationDetail => {
    return {...dest, accountsGroups: copyShown(src.accountsGroups, dest.accountsGroups)};
};

function keepExpandedGroups(state: ApplicationDetail[], applicationDetail: ApplicationDetail): ApplicationDetail[] {
    // find old application detail with expanded groups
    let old = state.find(detail => detail.appId === applicationDetail.appId);

    let newDetail = applicationDetail;

    // if found copy expanded flag
    if (old) {
        newDetail = keepShown(old, applicationDetail);
    }

    // remove old - if present
    let newState = state.filter(detail => detail.appId !== applicationDetail.appId);
    return [...newState, newDetail];
}

type Actions = application.Actions
    | applicationDelete.Actions;

export const applicationDetails = (state: ApplicationDetail[] = [], action: Actions) => {
    switch (action.type) {
        case application.LOAD_SUCCESS:
        case application.REVERT_PERMISSIONS_FINISH:
            return keepExpandedGroups(state, action.payload);
        case application.TOGGLE_ACCOUNT_GROUP:
            return state.map(g => toggleAppDetailAccountGroup(g, action));
        case application.TOGGLE_ENABLE_PRODUCT:
            return state.map(g => toggleAppDetailEnableProduct(g, action));
        case applicationDelete.DELETE_SUCCESS:
            return state.filter(detail => detail.appId !== action.payload);
        case application.REMOVE_DETAIL:
            return state.filter(detail => detail.appId !== action.payload.appId);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/reducers/application-details/application-details.reducer.ts